// extracted by mini-css-extract-plugin
module.exports = {"loadMoreButton":"_base-load-more_loadMoreButton_22pc-","iconArrowDown":"_base-load-more_iconArrowDown_3I9Ve"};